import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AuthLayout from '../../templates/AuthLayout';
import PasswordForgotForm from '../../molecules/form/PasswordForgot';
import { Helmet } from 'react-helmet';
import Notice from '../../molecules/Notice';
import { useTranslation } from 'react-i18next';
const PasswordForgot = ({ notice, }) => {
    const { t } = useTranslation();
    return (_jsxs(AuthLayout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('password_reset.forgot_title') }) }), notice && _jsx(Notice, { ...notice }), _jsx(PasswordForgotForm, {})] }));
};
export default PasswordForgot;
